module.exports = __webpack_public_path__ + "img/wps-logo.bba7c49d.png";